<template>
  <div class="app-main-content ruleEngineSetup">
    <div class="grid-view">
      <div class="main-content">
        <div class="section operations" style="height: 39px;">
          <div class="triggers">
            <div>
              <el-button v-show="!rulesMaintenance" type="primary" size="mini" @click="rulesAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
              <el-button v-show="!rulesMaintenance" type="primary" :disabled="editableOrNoe.rules === 0" size="mini" @click="rulesEdit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
              <el-button v-show="!rulesMaintenance" type="danger" :disabled="!editableOrNoe.rules || isCheck" size="mini" @click="rulesDeletes">{{ $t('CargoMsg.Cargo_OrderDelete') }}</el-button>
              <el-button v-show="rulesMaintenance" type="primary" size="mini" @click="ruleSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
              <el-button v-show="rulesMaintenance" type="primary" size="mini" @click="rulesCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="left rules">
            <div class="center">
              <div class="left-border">
                <span class="title-positoon">{{ $t('CargoMsg.Cargo_ReconciliationRule') }}</span>
                <div style="position:relative;">
                  <div v-show="isCheck" class="mask" />
                  <cargo-ag-grid
                    config-module="191265"
                    :grid-options="rulesGridOptions"
                    :column-defs="rulesColumnDefs"
                    :row-data="rulesData"
                  />
                </div>

                <el-form v-show="rulesMaintenance" :model="rulesForm" label-width="100px" label-position="left">
                  <el-form-item :label="$t('CargoMsg.Cargo_ReconciliationRuleName')" class="spacing">
                    <el-input v-model="rulesForm.ruleName" tyle="text" style="width:286px;" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_BranchCMP')" class="spacing">
                    <cargo-advance-select
                      :select-type="TYPE_NAMES.static_data_Office"
                      filter-type="global"
                      multiple
                      filterable
                      :default-multiple-value="branch"
                      style="width:286px;"
                      :static-options="branchList"
                      :placeholder="$t('CargoMsg.Cargo_PleaseSelectBranch')"
                      @parentCallBack="p=>{branch=p.value}"
                    />
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="center">
              <div class="left-border right-border">
                <span class="title-positoon">{{ $t('CargoMsg.Cargo_MatchFieldSettings') }}</span>
                <div>
                  <el-button v-show="!matchingFieldSettings" type="primary" :disabled="rulesAddOrEdit == '1'" @click="matchingFieldAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
                  <el-button v-show="matchingData.length !== 0 && !matchingFieldSettings" :disabled="editableOrNoe.matching === 0" type="primary" @click="matchingFieldEdit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
                  <el-button v-show="matchingData.length !== 0 && !matchingFieldSettings" :disabled="!matchingIsChecked || matchingMask" type="danger" @click="matchingFieldDeletes">{{ $t('CargoMsg.Cargo_OrderDelete') }}</el-button>
                  <el-button v-show="matchingFieldSettings" type="primary" size="mini" @click="matchingFieldSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
                  <el-button v-show="matchingFieldSettings" type="primary" size="mini" @click="matchingCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
                </div>
                <span class="remind">{{ $t('CargoMsg.Cargo_PleaseSelectField') }}</span>
                <div style="position:relative;">
                  <div v-show="matchingMask" class="mask" />
                  <cargo-ag-grid
                    config-module="191266"
                    :grid-options="matchingGridOptions"
                    :column-defs="matchingColumnDefs"
                    :row-data="matchingData"
                  />
                </div>

                <el-form v-show="matchingFieldSettings" label-width="100px" :model="matchingFieldSettingsForm" label-position="left">
                  <el-form-item :label="$t('CargoMsg.Cargo_Relationship')" class="spacing">
                    <el-radio-group v-model="matchingFieldSettingsForm.relation">
                      <el-radio :label="relationMap.and">{{ $t('CargoMsg.Cargo_And') }}</el-radio>
                      <el-radio :label="relationMap.or">{{ $t('CargoMsg.Cargo_Or') }}</el-radio>
                    </el-radio-group>

                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_MatchingOrder')" class="spacing">
                    <el-input v-model="matchingFieldSettingsForm.matchOrder" type="number" style="width:200px;" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_MatchFieldName')" class="spacing">
                    <el-select v-model="matchingFieldSettingsForm.tableColumnName" style="width:200px;" :placeholder="$t('CargoMsg.Cargo_PleaseSelect')">
                      <el-option
                        v-for="(item, index) in matchFieldSelectList"
                        v-show=" index !== '金额'"
                        :key="item"
                        :label="index"
                        :value="index"
                      />
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>

              <div class="left-border right-border">
                <span class="title-positoon">{{ $t('CargoMsg.Cargo_CompareFieldOperations') }}</span>
                <div>
                  <el-button v-show="!contrastFieldSettings" type="primary" :disabled="rulesAddOrEdit == '1'" @click="compareFieldAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
                  <el-button v-show="comparisonData.length !== 0 && !contrastFieldSettings" :disabled="editableOrNoe.contrast === 0" type="primary" @click="compareFieldEdit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
                  <el-button v-show="comparisonData.length !== 0 && !contrastFieldSettings" :disabled="!contrastIsChecked || contrastMask" type="danger" @click="compareFieldDeletes">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
                  <el-button v-show="contrastFieldSettings" type="primary" size="mini" @click="compareFieldSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
                  <el-button v-show="contrastFieldSettings" type="primary" size="mini" @click="compareFieldCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
                </div>
                <span class="remind">{{ $t('CargoMsg.Cargo_SelectFieldToCompare') }}</span>
                <div style="position:relative;">
                  <div v-show="contrastMask" class="mask" />
                  <cargo-ag-grid
                    config-module="191267"
                    :grid-options="comparisonGridOptions"
                    :column-defs="comparisonColumnDefs"
                    :row-data="comparisonData"
                  />
                </div>

                <el-form v-show="contrastFieldSettings" label-width="100px" label-position="left">
                  <el-form-item :label="$t('CargoMsg.Cargo_Relationship')" :model="contrastFieldSettingsForm" class="spacing">
                    <el-radio-group v-model="contrastFieldSettingsForm.relation">
                      <el-radio :label="relationMap.and">{{ $t('CargoMsg.Cargo_And') }}</el-radio>
                      <el-radio :label="relationMap.or">{{ $t('CargoMsg.Cargo_Or') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_CompareOrder')" class="spacing">
                    <el-input v-model="contrastFieldSettingsForm.matchOrder" type="number" style="width:200px;" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_CompareField')" class="spacing">
                    <el-select v-model="contrastFieldSettingsForm.tableColumnName" style="width:200px;" :placeholder="$t('CargoMsg.Cargo_PleaseSelect')">
                      <el-option
                        v-for="(item, index) in matchFieldSelectList"
                        v-show="index === '金额'"
                        :key="item"
                        :label="index"
                        :value="index"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_ComparisonOperation')" class="spacing">
                    <el-select v-model="contrastFieldSettingsForm.operationType" style="width:200px;" :placeholder="$t('CargoMsg.Cargo_PleaseSelect')">
                      <el-option
                        v-for="item in compareFieldSelectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getGridSelected } from '@/utils/agGrid'
import { cacheName, cache } from '@/utils/cacheManager'
import { matchFieldList, compareFieldList, queryTableColumnName, updateRuleOperation, deleteRuleOperation, deleteRuleMatch, updateRuleMatch, deleteRule, updateRule, queryRuleList, saveRule, saveRuleMatch, saveRuleOperation } from '@/api/sysManage/ruleEngineSetup'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
export default {
  name: 'RuleEngineSetup',
  components: { CargoAdvanceSelect },
  data() {
    return {
      TYPE_NAMES,
      val: '',
      relationMap: {
        and: 1,
        or: 2
      },
      editableOrNoe: {
        rules: 0,
        matching: 0,
        contrast: 0
      },
      rulesAddOrEdit: '1', // 规则 1新增 2编辑
      matchNewOrEdit: '1', // 匹配字段 1新增 2编辑
      contrastNewOrEdit: '1', // 对比字段 1新增 2编辑
      // 对比规则
      rulesMaintenance: false,
      rulesForm: {
        ruleName: '',
        officeIds: '',
        officeNames: ''
      },
      branch: [],
      isCheck: false,
      matchingMask: false,
      contrastMask: false,
      // 匹配字段
      matchingFieldSettings: false,
      matchingFieldSettingsForm: {
        matchOrder: '',
        relation: 1,
        tableColumnName: ''
      },
      // 对比字段
      contrastFieldSettings: false,
      contrastFieldSettingsForm: {
        relation: 1, // 关系
        matchOrder: '', // 顺序
        tableColumnName: '', // 对比字段
        operationType: '' // 对比操作
      },
      isChecked: false,
      selectedRows: {},
      matchingRows: {},
      contrastRows: {},
      matchingIsChecked: false,
      contrastIsChecked: false,
      rulesGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        onSelectionChanged: this.rulesChanged,
        onCellClicked: params => {
          this.onCellClicked(params)
        },
        onRowClicked: (params) => {
          console.log('params', params)
          if (params.data) {
            this.editableOrNoe.rules = 1
          }
          this.selectedRows = params.data
        }
      },
      matchingGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        onSelectionChanged: this.matchingChanged,
        onRowClicked: (params) => {
          if (params.data) {
            this.editableOrNoe.matching = 1
          }
          this.matchingRows = params.data
        }
      },
      comparisonGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        onSelectionChanged: this.comparisonChanged,
        onRowClicked: (params) => {
          if (params.data) {
            this.editableOrNoe.contrast = 1
          }
          this.contrastRows = params.data
        }
      },
      options: [
        {
          tableColumnName: 'MBL NO.',
          value: 'MBL'
        },
        {
          tableColumnName: 'SO NO.',
          value: 'SONO'
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_ChargeName'),
          value: 'CHARGEITEMNAME'
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_Currency'),
          value: 'CURRENCY'
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_Amount'),
          value: 'AMOUNT'
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_ContainerNo'),
          value: 'CONTAINERNO'
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'),
          value: 'VESSEL'
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_VoyageNo'),
          value: 'VOYAGE_FLIGHT'
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_BusinessNo'),
          value: 'JOBNO'
        },
        {
          tableColumnName: this.$t('Invoice.invoice_invoiceNo'),
          value: 'INVOICENO'
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_WarehouseNo'),
          value: 'WAREHOUSE_NO'
        },
        {
          tableColumnName: this.$t('SeaExport.HblNo'),
          value: 'HBL_NBR2'
        },
        {
          tableColumnName: this.$t('SeaExport.BusinessReferenceNo'),
          value: 'CUSTOMER_REF_NO'
        }
      ],
      branchList: [], // 分公司数据
      matchFieldSelectList: {}, // 匹配字段名称
      compareFieldSelectList: [
        {
          name: this.$t('CargoMsg.Cargo_MultiRowSumMethod'),
          id: 1
        },
        {
          name: this.$t('CargoMsg.Cargo_ComparisonSingleLine'),
          id: 2
        }
      ],
      andOr: {
        1: this.$t('CargoMsg.Cargo_And'),
        2: this.$t('CargoMsg.Cargo_Or')
      },
      rulesData: [],
      matchingData: [],
      comparisonData: [],
      rulesColumnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReconciliationRuleName'),
          field: 'ruleName',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BranchCMP'),
          field: 'officeNames',
          width: 150
        }
      ],
      matchingColumnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MatchingOrder'),
          field: 'matchOrder',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MatchFieldName'),
          field: 'tableColumnName',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Relationship'),
          field: 'relationName',
          width: 150
        }
      ],
      comparisonColumnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CompareOrder'),
          field: 'matchOrder',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CompareField'),
          field: 'tableColumnName',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ComparisonOperation'),
          field: 'operationName',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Relationship'),
          field: 'relationName',
          width: 150
        }
      ]
    }
  },
  computed: {
    tableColumnNameValObj() {
      const obj = {}
      this.options.map((item) => {
        obj[item.value] = item.tableColumnName
      })
      return obj
    },
    compareFieldObj() {
      const obj = {}
      this.compareFieldSelectList.map((item) => {
        obj[item.id] = item.name
      })
      return obj
    },
    branchObj() {
      const obj = {}
      this.branchList.forEach((item) => {
        obj[item.officeId] = item.chineseName
      })
      return obj
    }
  },
  mounted() {
    this.getRuleList()// 获取对账规则列表
    this.prepareData()// 获取分公司下拉框数据
    this.getSelectData()// 获取匹配字段名称、对比字段下拉数据
  },
  methods: {
    // 获取对账规则列表
    getRuleList() {
      const self = this
      queryRuleList().then((res) => {
        if (res.data) {
          this.editableOrNoe.rules = 0
          self.rulesData = res.data
        } else {
          self.rulesData = []
        }
      })
    },
    // 获取匹配字段列表
    getMatchFieldList(ruleUuid) {
      const self = this
      matchFieldList(ruleUuid).then((res) => {
        if (res.data) {
          res.data.map((item) => {
            item.relationName = self.andOr[item.relation]
            item.tableColumnName = self.tableColumnNameValObj[item.tableColumnName]
          })
          self.matchingData = res.data
          self.matchNewOrEdit = '2'
        } else {
          // 没有匹配规则数据，点击编辑对账规则，右边匹配列表实际调用为新增
          self.matchNewOrEdit = '1'
          self.matchingData = []
        }
      })
    },
    // 获取对比字段列表
    getCompareFieldList(ruleUuid) {
      const self = this
      compareFieldList(ruleUuid).then((res) => {
        if (res.data) {
          res.data.map((item) => {
            item.operationName = self.compareFieldObj[item.operationType]
            item.relationName = self.andOr[item.relation]
            item.tableColumnName = self.tableColumnNameValObj[item.tableColumnName]
          })
          self.comparisonData = res.data
          self.contrastNewOrEdit = '2'
        } else {
          // 没有对比规则数据，点击编辑对账规则，右边对比列表实际调用为新增
          self.compareFieldAdd()
          self.comparisonData = []
        }
      })
    },
    // 对账规则新增按钮
    rulesAdd() {
      this.rulesMaintenance = true// 展开新增表单
      this.rulesAddOrEdit = '1'
      this.ruleInit()
      this.matchingInit()
      this.contrastInit()
      this.isCheck = false
      this.comparisonData = []
      this.matchingData = []
      this.branch = []
      this.rulesGridOptions.api.deselectAll()
      this.matchingFieldSettings = false
      this.contrastFieldSettings = false
    },
    // 对账规则编辑按钮
    async rulesEdit() {
      const data = await getGridSelected(this.rulesGridOptions)
      if (data.length > 1) {
        this.$message.warning(this.$t('Clearing.PleaseCheckARecord'))
      } else {
        this.rulesAddOrEdit = '2'
        this.isCheck = true
        this.contrastMask = false
        this.matchingMask = false
        // 选中项的数据
        if (!this.isChecked) {
          this.rulesForm = JSON.parse(JSON.stringify(this.selectedRows))
        } else {
          this.rulesForm = { ...JSON.parse(JSON.stringify(data[0])) }
        }
        this.rulesMaintenance = true
        this.rulesGridOptions.suppressRowClickSelection = false
        const officeIds = this.rulesForm.officeIds
        this.branch = officeIds ? officeIds.split(',').map(_ => +_) : []
        // 返回的字段转换成对应分公司名字
        this.getMatchFieldList(this.rulesForm.uuid)
        this.getCompareFieldList(this.rulesForm.uuid)
      }
    },
    // 对账规则保存按钮
    ruleSave() {
      if (!this.rulesForm.ruleName) {
        this.$message.warning(this.$t('Clearing.PleaseAReconciliationRuleName'))
        return false
      }
      if (this.branch.length === 0) {
        this.$message.warning(this.$t('Clearing.PleaseSelectABranch'))
        return false
      }
      const arr = this.branch.map((item) => {
        return this.branchObj[item]
      })
      const officeNames = arr.join(',')
      const officeIds = this.branch.join(',')
      // 1调用新增 2调用编辑接口
      if (this.rulesAddOrEdit === '1') {
        this.rulesNewFunc(officeIds, officeNames)
      }
      if (this.rulesAddOrEdit === '2') {
        this.updateRuleFunc(officeIds, officeNames)
      }
    },
    // 对账规则取消按钮
    rulesCancel() {
      this.rulesMaintenance = false
      this.rulesAddOrEdit = '1'
      this.editableOrNoe.matching = 0
      this.editableOrNoe.contrast = 0
      this.isCheck = false
      this.ruleInit()
      this.matchingInit()
      this.contrastInit()
      this.comparisonData = []
      this.matchingData = []
      this.branch = []
      this.matchingFieldSettings = false
      this.contrastFieldSettings = false
      this.rulesGridOptions.api.deselectAll()
    },
    // 对账规则删除
    rulesDeletes() {
      const self = this
      // 选中项的数据
      const data = [...getGridSelected(self.rulesGridOptions)]
      const uuidList = []
      data.forEach((item) => {
        uuidList.push(item.uuid)
      })
      deleteRule(uuidList).then((res) => {
        if (res.ok) {
          self.getRuleList()
          self.$message.success(this.$t('Clearing.DeleteSuccessful'))
          self.editableOrNoe.rules = 0
        }
      })
    },
    // 单击选中数据带到映射关系
    onCellClicked(params) {
      if (!this.rulesForm.officeIds) {
        this.getMatchFieldList(params.data.uuid)
        this.getCompareFieldList(params.data.uuid)
        this.contrastMask = true
        this.matchingMask = true
      }
    },
    // 对账规则新增接口调用
    async rulesNewFunc(officeIds, officeNames) {
      const data = {
        officeIds: officeIds,
        officeNames: officeNames,
        ruleName: this.rulesForm.ruleName,
        tenantId: this.$store.getters.tenantId
      }
      const res = await saveRule(data).then(res => res)
      if (res.ok) {
        this.getRuleList()
        this.rulesMaintenance = false
      }
    },
    // 对账规则编辑接口调用
    async updateRuleFunc(officeIds, officeNames) {
      const data = {
        createdBy: this.rulesForm.createdBy,
        officeIds: officeIds,
        officeNames: officeNames,
        dateCreated: this.rulesForm.dateCreated,
        dateModified: this.rulesForm.dateModified,
        modifiedBy: this.rulesForm.modifiedBy,
        ruleName: this.rulesForm.ruleName,
        tenantId: this.rulesForm.tenantId,
        uuid: this.rulesForm.uuid,
        version: this.rulesForm.version
      }
      const res = await updateRule(data).then(res => res)
      if (res.ok) {
        // 编辑完重置表格数据
        this.getRuleList()
        this.ruleInit()
        this.matchingInit()
        this.contrastInit()
        this.comparisonData = []
        this.matchingData = []
        this.branch = []
        this.rulesAddOrEdit = '1'
        this.matchingFieldSettings = false
        this.contrastFieldSettings = false
        this.rulesMaintenance = false
        this.isCheck = false
        this.editableOrNoe.rules = 0
      }
    },
    // 匹配字段新增按钮
    matchingFieldAdd() {
      if (this.rulesAddOrEdit === '2') {
        this.matchNewOrEdit = '1'
        this.matchingFieldSettings = true
        this.matchingMask = false
        this.matchingGridOptions.api.deselectAll()
        this.matchingInit()
      } else {
        this.$message.warning(this.$t('Clearing.PleaseReconciliationRuleToEdit'))
      }
    },
    // 匹配字段编辑按钮
    async matchingFieldEdit() {
      if (this.rulesAddOrEdit !== '2') {
        this.$message.warning(this.$t('Clearing.PleaseReconciliationRuleToEdit'))
        return
      }
      const data = await getGridSelected(this.matchingGridOptions)
      if (data.length > 1) {
        this.$message.warning(this.$t('Clearing.PleaseCheckARecord'))
      } else {
        this.matchNewOrEdit = '2'
        this.matchingMask = true
        // 选中项的数据
        if (!this.matchingIsChecked) {
          this.matchingFieldSettingsForm = JSON.parse(JSON.stringify(this.matchingRows))
        } else {
          this.matchingFieldSettingsForm = { ...JSON.parse(JSON.stringify(data[0])) }
        }
        this.matchingFieldSettings = true
      }
    },
    // 匹配字段取消按钮
    matchingCancel() {
      this.matchingFieldSettings = false
      this.matchingGridOptions.api.deselectAll()
      this.matchingMask = false
      this.matchingInit()
    },
    // 匹配字段保存按钮
    async matchingFieldSave() {
      if (this.matchingFieldSettings) {
        const { matchOrder, tableColumnName } = { ...this.matchingFieldSettingsForm }
        Promise.all([
          this.validation(matchOrder, this.$t('Clearing.PleaseTheMatchingFieldOrder')),
          this.validation(tableColumnName, this.$t('Clearing.PleaseTheMatchingFieldName'))
        ]).then((values) => {
          // 新增
          if (values && this.matchNewOrEdit === '1') {
            this.matchingNewFunc()
          }
          // 编辑
          if (values && this.matchNewOrEdit === '2') {
            this.updateMatchFunc()
          }
        }).catch((error) => {
          this.$message.warning(error)
        })
      }
    },
    // 匹配字段删除
    matchingFieldDeletes() {
      const self = this
      // 选中项的数据
      const data = [...getGridSelected(self.matchingGridOptions)]
      const uuidList = []
      data.forEach((item) => {
        uuidList.push(item.uuid)
      })
      deleteRuleMatch(uuidList).then((res) => {
        if (res.ok) {
          self.getMatchFieldList(self.rulesForm.uuid)
          this.matchingIsChecked = false
          self.$message.success('删除成功')
          self.editableOrNoe.matching = 0
        }
      })
    },
    // 匹配字段新增接口调用
    async matchingNewFunc() {
      const data = {
        matchOrder: this.matchingFieldSettingsForm.matchOrder, // 匹配顺序
        relation: this.matchingFieldSettingsForm.relation, // 1:and，2:or
        ruleUuid: this.rulesForm.uuid, // 规则UUID
        tableColumnName: this.matchFieldSelectList[this.matchingFieldSettingsForm.tableColumnName], // 匹配字段
        tenantId: this.$store.getters.tenantId
      }
      const res = await saveRuleMatch(data).then(res => res)
      if (res.ok) {
        this.matchingFieldSettings = false
        this.getMatchFieldList(this.rulesForm.uuid)
        this.matchingInit()
      }
    },
    // 匹配字段编辑接口调用
    async updateMatchFunc() {
      const data = {
        matchOrder: this.matchingFieldSettingsForm.matchOrder, // 匹配顺序
        relation: this.matchingFieldSettingsForm.relation, // 1:and，2:or
        ruleUuid: this.rulesForm.uuid, // 规则UUID
        tableColumnName: this.matchFieldSelectList[this.matchingFieldSettingsForm.tableColumnName], // 匹配字段
        tenantId: this.$store.getters.tenantId,
        uuid: this.matchingFieldSettingsForm.uuid
      }
      const res = await updateRuleMatch(data).then(res => res)
      if (res.ok) {
        this.matchingCancel()
        this.editableOrNoe.matching = 0
        this.getMatchFieldList(this.rulesForm.uuid)
      }
    },
    // 对比字段新增按钮
    compareFieldAdd() {
      if (this.rulesAddOrEdit === '2') {
        this.contrastNewOrEdit = '1'
        this.contrastMask = false
        this.comparisonGridOptions.api.deselectAll()
        this.contrastFieldSettings = true
        this.contrastInit()
      } else {
        this.$message.warning(this.$t('Clearing.PleaseReconciliationRuleToEdit'))
      }
    },
    // 对比字段编辑按钮
    async compareFieldEdit() {
      if (this.rulesAddOrEdit !== '2') {
        this.$message.warning(this.$t('Clearing.PleaseReconciliationRuleToEdit'))
        return
      }
      const data = await getGridSelected(this.comparisonGridOptions)
      if (data.length > 1) {
        this.$message.warning(this.$t('Clearing.PleaseCheckARecord'))
      } else {
        this.contrastNewOrEdit = '2'
        this.contrastMask = true
        // 选中项的数据
        if (!this.contrastIsChecked) {
          this.contrastFieldSettingsForm = JSON.parse(JSON.stringify(this.contrastRows))
        } else {
          this.contrastFieldSettingsForm = { ...JSON.parse(JSON.stringify(data[0])) }
        }
        this.contrastFieldSettingsForm = { ...data[0] }
        this.contrastFieldSettings = true
      }
    },
    // 对比字段取消按钮
    compareFieldCancel() {
      this.contrastFieldSettings = false
      this.comparisonGridOptions.api.deselectAll()
      this.contrastMask = false
      this.contrastInit()
    },
    // 对比字段保存按钮
    async compareFieldSave() {
      const { matchOrder, tableColumnName, operationType } = { ...this.contrastFieldSettingsForm }
      if (this.contrastFieldSettings) {
        Promise.all([
          this.validation(matchOrder, this.$t('Clearing.PleaseTheContrastFieldOrder')),
          this.validation(tableColumnName, this.$t('Clearing.PleaseTheContrastFieldName')),
          this.validation(operationType, this.$t('Clearing.PleaseTheContrastFieldOperation'))
        ]).then((values) => {
          if (values && this.contrastNewOrEdit === '1') {
            this.contrastNewFunc()
          }
          if (values && this.contrastNewOrEdit === '2') {
            this.contrastEditorFunc()
          }
        }).catch((error) => {
          this.$message.warning(error)
        })
      }
    },
    // 对比字段删除
    async compareFieldDeletes() {
      const self = this
      if (this.rulesAddOrEdit !== '2') {
        this.$message.warning(this.$t('Clearing.PleaseReconciliationRuleToEdit'))
        return
      }
      // 选中项的数据
      const data = [...getGridSelected(self.comparisonGridOptions)]
      const uuidList = []
      data.forEach((item) => {
        uuidList.push(item.uuid)
      })
      deleteRuleOperation(uuidList).then((res) => {
        if (res.ok) {
          self.getCompareFieldList(self.rulesForm.uuid)
          this.contrastIsChecked = false
          self.$message.success('删除成功')
          this.editableOrNoe.contrast = 0
        }
      })
    },
    // 对比字段新增接口调用
    async contrastNewFunc() {
      const data = {
        matchOrder: this.contrastFieldSettingsForm.matchOrder, // 匹配顺序
        relation: this.contrastFieldSettingsForm.relation, // 1:and，2:or
        tableColumnName: this.matchFieldSelectList[this.contrastFieldSettingsForm.tableColumnName],
        operationType: this.contrastFieldSettingsForm.operationType, // 匹配字段
        tenantId: this.$store.getters.tenantId,
        ruleUuid: this.rulesForm.uuid // 规则UUID
      }
      const receiveData = await saveRuleOperation(data).then(res => res.data)
      if (receiveData) {
        this.contrastFieldSettings = false
        this.getCompareFieldList(this.rulesForm.uuid)
        this.contrastInit()
      }
    },
    // 对比字段编辑接口调用
    async contrastEditorFunc() {
      const data = {
        matchOrder: this.contrastFieldSettingsForm.matchOrder, // 匹配顺序
        relation: this.contrastFieldSettingsForm.relation, // 1:and，2:or
        operationType: this.contrastFieldSettingsForm.operationType, // 对比操作
        tableColumnName: this.matchFieldSelectList[this.contrastFieldSettingsForm.tableColumnName], // 匹配字段
        tenantId: this.$store.getters.tenantId,
        ruleUuid: this.rulesForm.uuid,
        uuid: this.contrastFieldSettingsForm.uuid
      }
      const receiveData = await updateRuleOperation(data).then(res => res.ok)
      if (receiveData) {
        this.editableOrNoe.contrast = 0
        this.getCompareFieldList(this.rulesForm.uuid)
        this.compareFieldCancel()
      }
    },
    // 获取分公司
    async prepareData() {
      await cache.load(cacheName.OFFICE_LIST, cacheName.CONFIG)
      this.branchList = [{ officeId: 0, code: 'ALL', chineseName: '全部', englishName: 'All' }, ...cache.officeList]
    },
    // 获取匹配字段名称、对比字段下拉数据
    async getSelectData() {
      const receiveData = await queryTableColumnName().then(res => res.data)
      if (receiveData) {
        this.matchFieldSelectList = receiveData
      }
    },
    // 对账规则表单初始化
    ruleInit() {
      this.rulesForm = {
        ruleName: '',
        officeIds: '',
        officeNames: ''
      }
      this.branch = []
    },
    // 匹配字段表单初始化
    matchingInit() {
      this.matchingFieldSettingsForm = {
        matchOrder: '',
        relation: this.relationMap.and,
        tableColumnName: ''
      }
    },
    // 对比字段表单初始化
    contrastInit() {
      this.contrastFieldSettingsForm = {
        relation: this.relationMap.and, // 关系
        matchOrder: '', // 顺序
        tableColumnName: '', // 对比字段
        operationType: '' // 对比操作
      }
    },
    // 未选择数据时禁止按钮点击
    rulesChanged(event) {
      const rows = event.api.getSelectedRows()
      if (rows.length > 0) {
        this.isChecked = true
      } else {
        this.isChecked = false
      }
      this.editableOrNoe.rules = rows.length
      // 取消勾选对账规则时，把列表数据
      if (this.editableOrNoe.rules === 0) {
        this.ruleInit()
        this.rulesGridOptions.suppressRowClickSelection = true
      }
    },
    matchingChanged(event) {
      const rows = event.api.getSelectedRows()
      if (rows.length > 0) {
        this.matchingIsChecked = true
      } else {
        this.matchingIsChecked = false
      }
      this.editableOrNoe.matching = rows.length
    },
    comparisonChanged(event) {
      const rows = event.api.getSelectedRows()
      if (rows.length > 0) {
        this.contrastIsChecked = true
      } else {
        this.contrastIsChecked = false
      }
      this.editableOrNoe.contrast = rows.length
    },
    // 检验字段
    validation(value, text) {
      if (!value) {
        return Promise.reject(text)
      }
      return true
    }
  }
}
</script>
<style scoped lang="scss">
.ruleEngineSetup{
  .content{
    height: 100%;
    display: flex;
    justify-content: space-between;
    .left,.right{
      width: 50%;
    }
    .center{
      display:flex;
      justify-content: center;
      flex-direction: column;
      align-items: flex-start;
      margin-top: 15px;
      .left-border,.right-border{
        width: 90%;
        border-radius: 5px;
        border: 1px solid #000000;
        position: relative;
        padding: 30px;
        box-sizing: border-box;
        .title-positoon{
          position: absolute;
          left: 30px;
          top: -6px;
          background-color: #e2e8f3;
          padding: 0 5px;
        }
        .remind{
          margin:15px 0 5px 0;
          display:block;
        }
        .spacing{
          margin-top: 20px;
        }
      }
      .right-border{
        margin-bottom: 20px;
      }
    }
    .mask{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 999;
    }
  }
}

</style>

